// Native equivalents of the lodash helpers this used: `pickBy(o, ['isSelected', true])` (the
// matchesProperty shorthand) pulled lodash's deep-equality machinery into the homepage bundle.
const selectedOf = (products) => Object.fromEntries(Object.entries(products).filter(([, product]) => product.isSelected === true));

import setUpScrollIndicator from '@/scripts/components/scrollIndicator';
import {$$} from '@/scripts/utils/dom';

export default class Filter {
  constructor() {

    this.selectors = {
      tagsJson: '[data-product-json]',
      filterTags: '[data-tag-member]',
    };

    this.classes = {
      selectedClass: 'selected',
      active: 'active',
      unselectableClass: 'unselectable'
    }

    this.products = [];
    this.allTags = [];
    this.selectedTags = [];

    this.init();
  }

  setUpProducts() {
    let context = this;
    $$(this.selectors.tagsJson).forEach(function (element) {
      let productSingleObject = JSON.parse(
        element.textContent,
      );
      context.products[productSingleObject.handle] = {};
      context.products[productSingleObject.handle].tags = productSingleObject.tags;
      context.products[productSingleObject.handle].isSelected = true;
      context.products[productSingleObject.handle].element = $$("[data-title-" + productSingleObject.handle + "]");
    });
  }

  setUpFilter() {
    let context = this;
    for (var key in this.products) {
      this.products[key].tags.forEach((tag) => {
        if (!context.allTags.includes(tag)) {
          context.allTags.push(tag);
        }
      });
    }
  }

  setUpListeners() {
    let context = this;
    $$(this.selectors.filterTags).forEach((filterTag) => {
      filterTag.addEventListener('click', function (event) {
        context.processClick(event.target);
      });
    });
  }

  processClick(target) {
    if (target.classList.contains(this.classes.unselectableClass)) {
      return;
    }
    if (target.classList.contains(this.classes.selectedClass)) {
      target.classList.remove(this.classes.selectedClass);
      this.deselectTag(target.dataset.tag);
    }
    else {
      target.classList.add(this.classes.selectedClass);
      this.selectTag(target.dataset.tag)
    }
    this.updateTags();
  }

  selectTag(tag) {
    this.selectedTags.push(tag);
    this.updateProducts(tag, "add");
  }

  deselectTag(tag) {
    for (let index = this.selectedTags.length - 1; index >= 0; index--) {
      if (this.selectedTags[index] === tag) {
        this.selectedTags.splice(index, 1);
      }
    }
    this.updateProducts(tag, "remove");
  }

  updateProducts(tag, action) {
    if (this.selectedTags.length == 0) {
      for (var key in this.products) {
        this.products[key].element.forEach((element) => element.classList.add(this.classes.active));
        this.products[key].isSelected = true;
      }
    }
    else {
      for (var key in this.products) {
        if (this.selectedTags.every((selectedTag) => this.products[key].tags.includes(selectedTag))) {
          this.products[key].element.forEach((element) => element.classList.add(this.classes.active));
          this.products[key].isSelected = true;
        }
        else {
          this.products[key].element.forEach((element) => element.classList.remove(this.classes.active));
          this.products[key].isSelected = false;
        }
      }
    }
    let numSelected = Object.keys(selectedOf(this.products));
    const selectedFragrances = document.getElementById('selected-fragrances');
    if (selectedFragrances) {
      selectedFragrances.innerHTML = numSelected.length;
    }

    const countPhrases = $$('.home__filter__count-phrase');
    const countClears = $$('.home__filter__count-clear');

    if (numSelected.length < 5) {
      countPhrases.forEach((element) => {
        element.innerHTML = 'We recommend';
      });
      countClears.forEach((element) => element.classList.add('active'));
    } else if (numSelected.length === 5) {
      countPhrases.forEach((element) => {
        element.innerHTML = 'Find your match';
      });
      countClears.forEach((element) => element.classList.remove('active'));
    }

    countClears.forEach((countClear) => {
      countClear.addEventListener('click', function () {
        $$('.selector__container li.selected').forEach((element) => element.click());
      });
    });
  }

  updateTags() {
    let remainingTags = this.allTags.filter((tag) => !this.selectedTags.includes(tag));
    let selectedProducts = selectedOf(this.products);
    remainingTags.forEach((tag) => {
      let remainingSelectableProducts = false;
      for (const product in selectedProducts) {
        if (this.products[product].tags.includes(tag)) {
          remainingSelectableProducts = true;
          break;
        }
      }
      if (remainingSelectableProducts == true) {
        $$('*[data-tag="' + tag + '"]').forEach((element) => element.classList.remove(this.classes.unselectableClass));
      }
      else {
        $$('*[data-tag="' + tag + '"]').forEach((element) => element.classList.add(this.classes.unselectableClass));
      }
    });
  }

  init() {
    const tagsJson = document.querySelector(this.selectors.tagsJson);
    if (!tagsJson || !tagsJson.textContent) {
      return;
    }

    this.setUpProducts();
    this.setUpFilter();
    this.setUpListeners();
    setUpScrollIndicator('.selector');
  }
}
